module.exports = __webpack_public_path__ + "assets/img/redis-cmd-hash-demo.f8de950e.png";